import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownPipe } from 'ngx-markdown';

@Component({
  selector: 'lib-faq-card',
  imports: [CommonModule, CdkAccordionModule, SvgIconComponent, TranslateModule, MarkdownPipe],
  templateUrl: './faq-card.component.html',
  styleUrl: './faq-card.component.scss',
})
export class FaqCardComponent {
  @Input() public question: string = '';
  @Input() public answer: string = '';
}
